import React, { useEffect, useState } from "react";
import { FaStar, FaStarHalfAlt, FaRegStar } from "react-icons/fa";
import { Link } from "react-router-dom";
import '../styles/Testimonios.css';

const testimoniosMock = [
  {
    id: 1,
    nombre: "Alejandra Manzano Castro",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8FYfS1z7HXQcEpnTvwfXFpOTercvWuME_lg&s",
    estrellas: 5,
    texto: "Se atendió mi hija con psicóloga y lo cierto es que le gustó mucho, se sintió en confianza. Hoy me atendí con dermatólogo y también muy buena atención. Ningún problema, ni con agendamiento de hora ni con la atención la cual fue oportuna y eficaz",
  },
  {
    id: 2,
    nombre: "Nicole Basso",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8FYfS1z7HXQcEpnTvwfXFpOTercvWuME_lg&s",
    estrellas: 5,
    texto: "Llegué a Formed en busca de atención dermatológica y tuve una muy buena experiencia con la doctora que me atendió (Giuponni). Hasta ahora el tratamiento indicado ha resultado muy efectivo, lo cual agradezco mucho, ya que se trata de zonas que son delicadas de tratar. En relación a mi experiencia en el centro, encuentro maravilloso tener acceso a diversas especialidades que se puedan costear mediante Fonasa. Si bien fuí por sobre cupo, el tiempo de espera no superó los 15 min. Lo recomiendo!!",
  },
  {
    id: 3,
    nombre: "Yuri Cataldo",
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR8FYfS1z7HXQcEpnTvwfXFpOTercvWuME_lg&s",
    estrellas: 4,
    texto: "Excelente atención y precios accesibles. El tiempo de la cita es muy corto, da la impresión de que en serio, pero no es así.",
  },
  
];

const renderStars = (rating) => {
  const fullStars = Math.floor(rating);
  const hasHalf = rating % 1 !== 0;
  const totalStars = 5;
  const stars = [];

  for (let i = 0; i < fullStars; i++) stars.push(<FaStar key={`full-${i}`} color="#FFD700" />);
  if (hasHalf) stars.push(<FaStarHalfAlt key="half" color="#FFD700" />);
  while (stars.length < totalStars) stars.push(<FaRegStar key={`empty-${stars.length}`} color="#FFD700" />);
  return stars;
};

const TestimoniosList = () => {
  const [testimonios, setTestimonios] = useState([]);

  useEffect(() => {
    setTestimonios(testimoniosMock);
  }, []);

  return (
    <div className="container my-5" id="testimoniosList">
    <h2 className="text-center mb-4">TESTIMONIOS</h2>


      <div className="testimonios-carousel-wrapper" id="testimonios-carousel-wrapper">
        <button
          id="especialidadesFlechaIzq"
          onClick={() => {
            document.querySelector("#testimonios-carousel-track").scrollBy({ left: -300, behavior: "smooth" });
          }}
        >
          ❮
        </button>

        <div id="testimonios-carousel-track" className="carousel-track">
          {testimonios.map((testimonio) => (
            <div key={testimonio.id} className="testimonio-card">
              <div className="testimonio-header">
                <img src={testimonio.img} alt={testimonio.nombre} className="testimonio-img" />
                <div>
                  <h6 className="nombre">{testimonio.nombre}</h6>
                  <div className="estrellas">{renderStars(testimonio.estrellas)}</div>
                </div>
              </div>
              <p className="texto">{testimonio.texto}</p>
            </div>
          ))}
        </div>

        <button
          id="especialidadesFlechaDer"
          onClick={() => {
            document.querySelector("#testimonios-carousel-track").scrollBy({ left: 300, behavior: "smooth" });
          }}
        >
          ❯
        </button>
      </div>

    </div>
  );
};

export default TestimoniosList;
